import './DownloadModal.scss'

import React, { Component } from 'react'
import { connectModal } from 'redux-modal'
import {Button, Modal} from 'react-bootstrap'

import OpTextbox from 'common/views/components/OpTextbox'

class CsvDownloadModal extends Component {
  constructor(props) {
    super(props)
    this.handleConfirm = this.handleConfirm.bind(this)
    this.onEmailAddressTextboxChange = this.onEmailAddressTextboxChange.bind(this)
    this.state = {
      emailAddress: this.props.email
    }
  }

  handleConfirm = () => {
    const {onConfirm, handleHide} = this.props
    onConfirm(this.state.emailAddress)
    handleHide()
    document.location.href = "/reports";
  }

  onEmailAddressTextboxChange = (e) => {
    let emailAddress = ''
    if (this.state.emailAddress) {
      emailAddress = this.state.emailAddress
    }
    emailAddress = e.target ? e.target.value: emailAddress
    this.setState({emailAddress: emailAddress})
  }

  render() {
    const { show, handleHide, exportTimeout } = this.props
    const prefix = exportTimeout ?  "It looks like this report may be too large to download immediately.": "This is a large report, so it may take a few minutes to generate."
    const message = `${prefix} Please enter your email address, and we will send you a link when it is ready.`
    return (
      <Modal className="DownloadModal" show={show}>
          <Modal.Header className="DownloadModal__header">
              <Modal.Title className="DownloadModal__header__title">
                  <div className="DownloadModal__header__title--text">Notify me when this report is ready</div>
                  <div className="DownloadModal__header__title--close" onClick={handleHide}/>
              </Modal.Title>
          </Modal.Header>

          <Modal.Body className="DownloadModal__body">
            <div className="DownloadModal__body--async-instructions">{message}</div>
            <OpTextbox
              label="Email address"
              iconClass="fa fa-user-circle"
              value={this.state.emailAddress}
              onChange={this.onEmailAddressTextboxChange}
            />
          </Modal.Body>

          <Modal.Footer className="DownloadModal__footer modal-footer">
            <div className="DownloadModal__footer--right">
              <Button id="finish-button" bsStyle="primary" onClick={this.handleConfirm}>Confirm</Button>
              <Button id="resend-button" bsStyle="default" onClick={handleHide}>Cancel</Button>
            </div>
          </Modal.Footer>
      </Modal>
    )
  }
}

const DownloadModal = connectModal({ name: 'DownloadModal', destroyOnHide: true })(CsvDownloadModal)

export default DownloadModal
